import axios from "axios";
import { first } from "lodash";

export const ORDER_SERVICE_CATEGORY: { [key: string]: string } = {
  electrical: "ระบบไฟฟ้า",
  water: "ระบบประปา",
  floor: "งานปูน/พื้น/กระเบื้อง",
  aluminium: "งานเหล็ก/อลูมิเนียม/ไม้",
  ceiling: "งานฝ้า/หลังคา",
  paint: "งานทาสี",
  contractor: "ผู้รับเหมา",
  architect: "ออกแบบ/สถาปนิก",
};

export enum ORDER_SERVICE_STATUS {
  CREATED = "CREATED",
  ACCEPT = "ACCEPT",
  REJECT = "REJECT",
  CANCEL = "CANCEL",
}

export const ORDER_SERVICE_STATUS_TEXT: { [key: string]: string } = {
  CREATED: "มาใหม่",
  ACCEPT: "งานที่รับแล้ว",
  REJECT: "งานที่ปฏิเสธ",
  CANCEL: "ลูกค้ายกเลิก",
};

export const ORDER_SERVICE_STATUS_COLOR: { [key: string]: string } = {
  CREATED: "gray",
  ACCEPT: "green",
  REJECT: "red",
  CANCEL: "volcano",
};

export const categoryOrderService = (name: string) =>
  ORDER_SERVICE_CATEGORY[name];

export const getOrderServiceByOrderNo = async (orderNo: string) => {
  const {
    data: { data },
  } = await axios.get(`/order-service-jobs/orderNo/${orderNo}`);
  const orderService = first(data);
  return {
    type: "GET_ORDER_SERVICE_DETAIL",
    data: orderService,
  };
};

export const updateStatusToAccepted = async (orderNo: string) => {
  const {
    data: { data },
  } = await axios.patch(`/order-service-jobs/${orderNo}`, {
    status: ORDER_SERVICE_STATUS.ACCEPT,
  });
};

export const updateStatusToRejected = async (orderNo: string) => {
  const {
    data: { data },
  } = await axios.patch(`/order-service-jobs/${orderNo}`, {
    status: ORDER_SERVICE_STATUS.REJECT,
  });
};

export const sendNotiMessage = async (type: any, userId: any, jobId: any) => {
  //line-order-service/
  await axios.post(`/line/send-messages`, {
    type: type,
    userId,
    jobId: jobId,
  });
};

export const sendOwnerNotiMessage = async (type: any, userId: any) => {
  //line-order-service/
  await axios.post(`/line-order-service/owner/send-messages`, {
    type: type,
    userId,
  });
};

export const sendTechnicianNotiMessage = async (
  type: any,
  userId: any,
  category: any,
  province: any,
  url: any
) => {
  //line-order-service/
  await axios.post(`/line-order-service/technician/send-messages`, {
    type: type,
    userId,
    category: category,
    province: province,
    url: url,
  });
};
